import "bootstrap/dist/css/bootstrap.min.css";
import "./bootstrap.min.css";
import "semantic-ui-css/semantic.min.css";
import "./index.css";
import "moment/locale/pt-br";

import { persistor, store } from "./store";

import App from "./App";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";
import React from "react";
import ReactDOM from "react-dom";
import moment from "moment";
import reportWebVitals from "./reportWebVitals";

moment.locale("pt-br");

ReactDOM.render(
  <React.Fragment>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </React.Fragment>,
  document.getElementById("root")
);

reportWebVitals();
